export function calculatePercentage(
  numerator: number | undefined,
  denominator: number | undefined,
  round?: 'ceil' | 'floor',
) {
  if (!numerator || !denominator || denominator === 0) {
    return 0;
  }

  const percentage = (numerator / denominator) * 100;

  if (round == 'ceil') {
    return Math.ceil(percentage);
  }

  if (round === 'floor') {
    return Math.floor(percentage);
  }

  return percentage;
}
